import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProviderUserDashboard from '../../../components/ProviderUser/ProviderUserDashboard';
import ProviderSideBar from '../../../Container/ProviderSidebar/ProviderSideBar';
import ProviderInspireAnnouncements from '../../../components/ProviderUser/ProviderInspireAnnouncements';
import ShowAllPost from '../../../components/Post/ShowAllPost';
import PostDetilas from '../../../components/Post/PostDetilas';
import CreatePostWithOutCat from '../../../components/ProviderUser/CreatePostWithOutCat';
import ProviderProfile from '../../../components/ProviderUser/ProviderProfile';

const ProviderRoutes = () => {
  return (
    <div>
        
        <ProviderSideBar/>
        <div style={{marginLeft:280,marginTop:25}}>
        <Routes>
            <Route path='/provider-dashboard' element={<ProviderUserDashboard />} />              
            <Route path='/provider-inspire-announcement' element={<ProviderInspireAnnouncements />} /> 
            {/* <Route path="/subcategories/subcategory/:id" element={<ShowAllPost />} />  */}
            <Route path='/sub-category/:id' element={<ShowAllPost />} />
            <Route path='/post-details/:id' element={<PostDetilas />} />
            <Route path='/create-post' element={<CreatePostWithOutCat />} />
            <Route path='/user-profile/:id' element={<ProviderProfile />} />
           
                       
        </Routes>
    </div>
    </div>
  )
}

export default ProviderRoutes